import { expVal } from '@atlassian/jira-feature-experiments';
import { customFiltersResource } from '@atlassian/jira-router-resources-board-resource/src/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const conditionalCustomFiltersResource = resourceWithCondition(
	() => !expVal('filter_refinement_in_tmp_board', 'isEnabled', false),
	customFiltersResource,
);
